import { englishFormattedEuroCurrency } from '@getpopsure/public-utility';
import classNames from 'classnames';
import { SectionHeader } from 'components/sectionHeader';

import { Fields } from './components/Fields';
import { CalculatorFieldType, FieldsValues } from './models';
import styles from './style.module.scss';

export type GenericCalculatorConfig = {
  hasBackgroundColor?: boolean;
  title?: string;
  description?: string;
  cta?: {
    text: string;
    href: string;
    // displayOnlyWhenPriceIsAvailable?: boolean;
  };
  priceLabels?: {
    topLabel?: string;
    bottomLabel?: string;
    additionalInfo?: string;
  };
  fields: CalculatorFieldType[];
  price?: number;
};

export type GenericCalculatorViewProps = GenericCalculatorConfig & {
  onChange: (values: FieldsValues) => void;
};

export default (props: GenericCalculatorViewProps) => {
  const {
    hasBackgroundColor,
    title,
    description,
    cta,
    priceLabels,
    price,
    fields,
    onChange,
  } = props;

  return (
    <section
      className={classNames(styles.wrapper, {
        'bg-grey-100': hasBackgroundColor,
      })}
    >
      <div className={classNames('p-body mxauto my0', styles.container)}>
        {title && <SectionHeader title={title} titleClass="p-h2" />}

        <div className={styles.bgPattern} />
        <div
          className={`mt24 ml-auto mr-auto p32 px56 br8 bg-white ${styles.calculator}`}
        >
          {description && <div className="p-p tc-grey-600">{description}</div>}
          <div className="d-flex f-wrap ai-center jc-center c-gap72 r-gap40">
            <div className={`w100 ${styles.calculatorInputs}`}>
              {fields && <Fields fields={fields} onChange={onChange} />}
            </div>
            <div
              className={`d-flex fd-column ai-center w100 ${styles.calculatorOutput}`}
            >
              {priceLabels?.topLabel && (
                <p className="p-p--small tc-grey-600 mb4">
                  {priceLabels.topLabel}
                </p>
              )}
              <h3 className="p-h1--xl p--serif tc-primary-500 ta-center">
                {price ? englishFormattedEuroCurrency(price, true) : '€ —'}
              </h3>
              {priceLabels?.bottomLabel && (
                <p className="p-p fw-bold tc-primary-500 ta-center p--serif">
                  {priceLabels.bottomLabel}
                </p>
              )}
              {cta && (
                <a
                  className={`p-btn p-btn--primary mt24 w100 ${styles.quoteButton}`}
                  href={cta.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {cta.text}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
